// Cloudflare Turnstile, on-demand token generation.
// Graceful: if no site key is configured, returns undefined so forms still work.
const SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY;
let scriptPromise = null;

function loadScript() {
  if (window.turnstile) return Promise.resolve();
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    s.async = true;
    s.defer = true;
    s.onload = () => {
      const wait = () => (window.turnstile ? resolve() : setTimeout(wait, 25));
      wait();
    };
    s.onerror = reject;
    document.head.appendChild(s);
  });
  return scriptPromise;
}

// Returns a one-time Turnstile token (or undefined if unconfigured / unavailable).
export async function getTurnstileToken(action) {
  if (!SITE_KEY) return undefined;
  try {
    await loadScript();
  } catch {
    return undefined;
  }
  return new Promise((resolve) => {
    const el = document.createElement('div');
    // Fixed + centered: Cloudflare only shows it if a visitor must tick the box.
    Object.assign(el.style, { position: 'fixed', left: '50%', bottom: '24px', transform: 'translateX(-50%)', zIndex: '2147483000' });
    el.setAttribute('data-testid', 'turnstile-widget');
    document.body.appendChild(el);
    let done = false;
    let widgetId;
    let timer;
    const finish = (token) => {
      if (done) return;
      done = true;
      try { if (widgetId) window.turnstile.remove(widgetId); } catch { /* noop */ }
      try { el.remove(); } catch { /* noop */ }
      resolve(token);
    };
    try {
      widgetId = window.turnstile.render(el, {
        sitekey: SITE_KEY,
        action,
        appearance: 'interaction-only',
        callback: (token) => finish(token),
        'before-interactive-callback': () => {
          clearTimeout(timer);
          timer = setTimeout(() => finish(undefined), 90000);
          // Visitor must tick the box: show it centered on a dimmed screen with a short hint.
          Object.assign(el.style, { top: '0', left: '0', right: '0', bottom: '0', transform: 'none', display: 'flex', flexDirection: 'column',
            alignItems: 'center', justifyContent: 'center', gap: '12px', background: 'rgba(10,15,28,0.55)' });
          const hint = document.createElement('p');
          hint.textContent = 'One quick check: please tick the box to continue.';
          Object.assign(hint.style, { order: '-1', margin: '0', padding: '10px 18px', borderRadius: '999px', background: '#ffffff', color: '#0A0F1C', maxWidth: 'calc(100vw - 32px)', textAlign: 'center',
            font: '600 15px system-ui, sans-serif' });
          hint.setAttribute('data-testid', 'turnstile-hint');
          el.appendChild(hint);
        },
        'error-callback': () => finish(undefined),
        'expired-callback': () => finish(undefined),
      });
    } catch {
      finish(undefined);
    }
    // Never hang the form if the challenge stalls
    timer = setTimeout(() => finish(undefined), 15000);
  });
}
